(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseClearOrderController', PurchaseClearOrderController);

	PurchaseClearOrderController.$inject = [ 'Notification', '$uibModalInstance', '$rootScope', '$localStorage', '$state', 'Principal', 'ModuleSettings', '$translate' ];

	function PurchaseClearOrderController(Notification, $uibModalInstance, $rootScope, $localStorage, $state, Principal, ModuleSettings, $translate) {
		var vm = this;

		vm.clear = clear;
		vm.confirmClearOrder = confirmClearOrder;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmClearOrder() {
			$rootScope.purchaseOrderList = [];
			$rootScope.purchaseTotals = {
				total : 0,
				totalPvf : 0,
				totalDesc : 0
			};
			$uibModalInstance.close(true);
			delete $localStorage.purchaseOrder;
			Notification.warning({
				message : $translate.instant('pharmaPortalApp.pharmaPurchase.messages.allProductRemoveSuccess'),
				delay : 5000
			});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.purchasesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (!(account && account.company)) {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();